<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader />
		<crumbs :txt="a" type="2" height="43px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="gxBox">
				<div class="gxBoxL">
					<tree
						:treeData="treeData"
						@perList="perList"
						:defaultProps="{
							children: 'children',
							label: 'resourceClassificationName'
						}"
					/>
				</div>
				<div class="gxBoxR">
					<div class="gxBoxRB">
						<div class="zzAdminTabs">
							<div class="zzAdminTab">
								<div class="zzAdminItem active">全部显示</div>
							</div>
							<div class="zzAdminTabZj">
								常用工具共
								<span>{{ total }}</span>
								个结果
							</div>
						</div>
						<div class="zzAdminConts">
							<div class="zzAdminCont" v-if="perData.length">
								<div class="zzAdminG" v-for="(item, index) in perData" :key="index">
									<div class="zzAdminItemImg" @click="btnFn(item)">
										<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
									</div>
									<div class="zzAdminItemP" @click="btnFn(item)">
										<div class="zzAdminItemTit">
											<p>{{ item.title }}</p>
										</div>
										<div class="zzAdminItemCont" v-html="$extractText($txtGs(item.content))" :title="$extractText($txtGs(item.content))"></div>
										<div class="zzAdminItemFot">
											<div class="zzAdminItemk">
												<img src="@/assets/img/xiazai.svg" alt="" />
												<span>下载量：{{ item.downloadNum || 0 }}</span>
											</div>
											<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
											<!-- <div class="zzAdminItemk">
						  编写人：{{item.createNickName}}
						</div> -->
										</div>
									</div>
									<div class="zzAdminItemDel" @click="xzBtn(item)">下载</div>
								</div>
							</div>
							<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
							<div v-if="!perData.length">
								<el-empty description="暂无数据"></el-empty>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import tree from '@/components/pubComponents/tree';
import fenye from '@/components/pubComponents/fenye';
// 导入streamsaver
import { batchDownload } from '@/assets/js/xz';
import crumbs from '@/components/hearder/crumbs';
let names = '首页';

export default {
	name: 'changyGj',
	data() {
		return {
			type: 5, // 5互帮互助 6常用工具
			txt: '',
			yzType: '',
			a: [''],
			perData: [],
			treeData: [
				{
					resourceClassificationName: ''
				}
			],
			fullscreenLoading: false,
			flags: '',
			total: 0
		};
	},
	components: {
		userHeader,
		foot,
		fuHeader,
		tree,
		crumbs,
		fenye
	},
	methods: {
		async xzBtn(item) {
			if (item.resourceFileId.includes(',')) {
				let arr = item.resourceFileId.split(',');
				// 给数组循环赋值
				this.fullscreenLoading = true;
				let newArr = arr.map(async (is, index) => {
					let res = await this.$http.get('api/app/common/getUrl', {
						params: {
							fileId: is,
							id: index == 0 ? item.toolResourceId : '',
							type: index == 0 ? 3 : '',
							clientType: 1
						}
					}); // 年龄赋值等待
					return {
						name: res.fileName,
						url: res.msg
					};
				});
				// Promise接收一个数组
				let newArrs = await Promise.all(newArr);
				// 执行完毕，再往下走
				this.fullscreenLoading = false;
				console.log('最终加工好的数组结果：', newArrs);
				batchDownload(item.title, newArrs);
			} else {
				this.$xzFn(
					{
						fileId: item.resourceFileId,
						id: item.toolResourceId,
						clientType: 1,
						type: 3
					},
					(res) => {
						item.downloadNum += 1;
					}
				);
			}
		},
		btnFn(item) {
			this.$router.push({
				path: './hbDec',
				query: {
					conTxt: 1,
					txt: item.title,
					toolResourceId: item.toolResourceId,
					yzType: '1',
					tabFtxt: '资源列表',
					type: 6,
					flags: '',
					crumFlag: 1,
					tabFtxt: ['首页', '常用工具']
				}
			});
		},
		init() {
			console.log('有树');
			// 树 资源1 同步课件 2 优质课件 3 最新试卷 4 互助资源 5 工具资源
			this.$http
				.get('api/app/yydResourceClassification/list', {
					params: {
						categories: 5
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.treeData = res.data;
						console.log(this.treeData, 222);
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					...data,
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			// 共享互助
			this.$http
				.get('api/app/yydToolResource/list', {
					params: {
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		}
	},
	beforeRouteEnter(to, from, next) {
		if (from.meta.name) {
			names = from.meta.name;
			console.log(names, 96662);
		}
		next();
	},
	mounted() {
		const { type, txt, flags, yzType, tabFtxt } = this.$route.query;
		if (tabFtxt) {
			this.a = [names, tabFtxt];
		}
		this.type = type || 5;
		this.txt = txt || '';
		this.yzType = yzType || '';
		this.flags = flags || '';
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.zzAdminTabs {
	height: 50px;
	background: #ffffff;
	border-radius: 6px 6px 0px 0px;
	display: flex;
	justify-content: space-between;
	padding: 0 15px 0 26px;
	border-bottom: 1px solid #f3f4f7;
	align-items: center;
	.zzAdminTabZj {
		font-size: 14px;
		span {
			color: #1d7b3a;
		}
	}
	.zzAdminTab {
		display: flex;
		font-size: 18px;
		color: #979797;
		align-items: center;
		.zzAdminItem {
			margin-right: 52px;
			cursor: pointer;
		}
		.active {
			color: #000;
			font-weight: bold;
		}
	}
	.zzAdminUp {
		display: flex;
		align-items: center;
		color: #1d7b3a;
		font-size: 14px;
		height: 100%;
		cursor: pointer;
		img {
			width: 16px;
			height: 16px;
			margin-right: 7px;
		}
	}
}
.zzAdminConts {
	background: #ffffff;
	border-radius: 0px 0px 6px 6px;
	padding: 0 15px;
	.zzAdminCont {
		margin-bottom: 100px;
		.zzAdminG {
			display: flex;
			padding: 15px 0;
			border-bottom: 1px solid #f8f8f8;
			align-items: center;
			cursor: pointer;
			&:last-of-type {
				border-bottom: none;
			}
			.zzAdminItemImg {
				width: 100px;
				height: 100px;
				margin-right: 10px;
			}
			.zzAdminItemP {
				flex: 1;
				padding-right: 20px;
				.zzAdminItemJj {
					display: flex;
					align-items: center;
					.zzAdminItemJjI {
						padding: 0 10px;
						height: 20px;
						font-size: 12px;
						text-align: center;
						line-height: 20px;
						border-radius: 4px;
						margin-right: 10px;
						margin-bottom: 5px;
					}
					.zzAdminItemJjI0 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI1 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI2 {
						background: #f6fcf1;
						color: #5ec009;
					}
					.zzAdminItemJjI3 {
						background: #f1f7fe;
						color: #1675e5;
					}
					.zzAdminItemJjI4 {
						background: #fbf3ff;
						color: #bf2ff9;
					}
					.zzAdminItemJjI5 {
						background: #f2f7f3;
						color: #1d7b3a;
					}
				}
				.zzAdminItemCont {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 5;
					width: 601px;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 14px;
					margin-bottom: 5px;
					// 超出多行省略号
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.zzAdminItemFot {
					display: flex;
					align-items: center;
					.zzAdminItemk {
						display: flex;
						align-items: center;
						color: #8f9190;
						font-size: 12px;
						margin-right: 29px;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
						}
					}
				}
				.zzAdminItemC {
					color: #aeaeae;
					font-size: 14px;
					width: 647px;
					margin-bottom: 5px;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
				.zzAdminItemTit {
					display: flex;
					align-items: center;
					margin-bottom: 6px;
					.zzAdminItemStat {
						width: 44px;
						height: 20px;
						background: #1d7b3a;
						font-size: 14px;
						color: #fff;
						margin-right: 10px;
						border-radius: 4px;
						text-align: center;
						line-height: 20px;
					}
					p {
						font-size: 16px;
						color: #000000;
						font-weight: bold;
					}
					.infoMyIcon {
						display: flex;
						align-items: center;
						color: #93571c;
						font-size: 14px;
						margin-left: 14px;
						img {
							width: 14px;
							height: 14px;
							margin-right: 4px;
						}
					}
					.zzAdminItemYuy {
						display: flex;
						align-items: center;
						color: #93571c;
						font-size: 14px;
						margin-left: 25px;
						img {
							width: 14px;
							height: 14px;
							margin-right: 5px;
						}
					}
				}
			}
			.zzAdminItemDel {
				width: 75px;
				height: 30px;
				background: #1d7b3a;
				margin-right: 14px;
				cursor: pointer;
				text-align: center;
				line-height: 30px;
				color: #fff;
				border-radius: 6px;
				font-size: 14px;
				margin-top: -7px;
			}
		}
	}
}
.gxBox {
	width: 1200px;
	margin: 0 auto 10px;
	display: flex;
	min-height: calc(100vh - 394px);
	.gxBoxL {
		width: 230px;
		background: #ffffff;
		border-radius: 6px;
		padding: 17px 14px 0;
	}
	.gxBoxR {
		flex: 1;
		margin-left: 10px;
		.gxBoxRT {
			background: #ffffff;
			border-radius: 6px;
			margin-bottom: 10px;
			padding: 17px 17px 11px;
			.gxBoxRTbox {
				display: flex;
				flex-wrap: wrap;
				.gxBoxRTitem {
					padding: 0 10px;
					height: 36px;
					background: #f3f4f7;
					border-radius: 4px;
					text-align: center;
					line-height: 36px;
					color: #000000;
					font-size: 14px;
					cursor: pointer;
					margin-right: 26px;
					margin-bottom: 10px;
					// &:nth-of-type(9n){
					//   margin-right: 0;
					// }
				}
				.active {
					background: #e5f2e9;
					color: #1d7b3a;
				}
			}
			.gxBoxRTit {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				color: #949494;
				margin-bottom: 20px;
				span {
					display: flex;
					align-items: center;
					cursor: pointer;
				}
				img {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
		}
	}
}
</style>
